import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');
const IS_LT_LG = isLessThanBreakpoint('lg');

function getCardCount() {
  if (IS_LT_MD) return 1;
  if (IS_LT_LG) return 3;

  return 4;
}

export default function BreederProfilePastPuppiesSectionSkeleton({
  className
}) {
  return (
    <div
      className={classnames(
        'BreederProfilePastPuppiesSectionSkeleton bg-subtle-light-gray pv8 pv20-md',
        className
      )}
    >
      <div className="container-xxl">
        <div className="mb5 mb6-md">
          <SkeletonBlock
            className="lh-title font-24 md:font-40 mb1"
            height="1em"
            width="8em"
          />
          <SkeletonBlock
            className="font-16 md:font-18"
            height="1em"
            width="30em"
          />
        </div>
        <div
          className={classnames('flex gap-16', {
            'flex-column': IS_LT_MD
          })}
        >
          {makeSequence(getCardCount()).map(index => (
            <SkeletonBlock
              key={index}
              className="br3"
              height={IS_LT_LG ? '340px' : '352px'}
              width="100%"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

BreederProfilePastPuppiesSectionSkeleton.propTypes = {
  className: PropTypes.string
};

BreederProfilePastPuppiesSectionSkeleton.defaultProps = {
  className: null
};
